import "./App.css";
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Pages/Home/Navbar";
import Home from "./Pages/Home/Homescreen";

// Loading component
const Loading = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: "'Space Grotesk', sans-serif",
    fontWeight: 900,
    fontSize: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    backgroundColor: '#FFFDF5',
    color: '#000000',
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Navbar />
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '100vh',
                  textAlign: 'center',
                  backgroundColor: '#FFFDF5',
                  fontFamily: "'Space Grotesk', sans-serif",
                  gap: '1.5rem',
                  padding: '2rem',
                  backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0.07) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.07) 1px, transparent 1px)',
                  backgroundSize: '40px 40px',
                }}>
                  <h1 style={{ fontSize: 'clamp(4rem, 15vw, 8rem)', fontWeight: 900, lineHeight: 1, textTransform: 'uppercase', letterSpacing: '-0.03em', WebkitTextStroke: '3px #000', color: 'transparent' }}>404</h1>
                  <p style={{ fontWeight: 900, fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.15em', background: '#FFD93D', border: '4px solid #000', padding: '0.3rem 1rem', boxShadow: '4px 4px 0 0 #000' }}>Page Not Found</p>
                  <a href="/" style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '0.875rem 1.75rem',
                    backgroundColor: '#FF6B6B',
                    color: '#000',
                    textDecoration: 'none',
                    border: '4px solid #000',
                    fontWeight: 900,
                    fontSize: '0.875rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    boxShadow: '8px 8px 0 0 #000',
                  }}>
                    Go Home
                  </a>
                </div>
              } />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </div>
  );
}

export default App;
